"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.role = exports.authorize = void 0;
var React = require("react");
var AuthorizeComponent_1 = require("./AuthorizeComponent");
var ROLES_KEY = "authorize:roles";
/**
 * Authorize decorator
 * @param constructor
 */
function authorize(constructor) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            var rolesVal = Reflect.getMetadata(ROLES_KEY, constructor);
            return (React.createElement(AuthorizeComponent_1.Authorize, { role: rolesVal }, _super.prototype.render.call(this)));
        };
        return class_1;
    }(constructor));
}
exports.authorize = authorize;
/**
 * Authorize decorator
 * @param constructor
 */
function role() {
    var value = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        value[_i] = arguments[_i];
    }
    return function (target) {
        if (Reflect.hasOwnMetadata(ROLES_KEY, target)) {
            throw new Error('Duplicate attribute: roles');
        }
        Reflect.defineMetadata(ROLES_KEY, value, target);
        return target;
    };
}
exports.role = role;
//# sourceMappingURL=authorize.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/authorize.js
// module id = 2132
// module chunks = 0